<template>
<!--  <img alt="Vue logo" src="./assets/logo.png">-->
<!--  <HelloWorld msg="Welcome to Your Vue.js App"/>-->
<!--    <a-spin :spinning="loading">-->
<!--      <MainPage/>-->
      <router-view></router-view>
<!--    </a-spin>-->
</template>

<script>
import MainPage from "@/components/MainPage.vue";

export default {
  name: 'App',
  components: {
      MainPage,
    // HelloWorld
  },
  data() {
      return {

      };
  },
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /*margin-top: 60px;*/
}
</style>
